import React, { memo } from 'react';
import PropTypes from 'prop-types';

import { compose } from 'redux';
import { connect } from 'react-redux';

import { useInjectReducer } from 'utils/injectReducer';
import { useInjectSaga } from 'utils/injectSaga';

import saga from './saga';
import reducer from './reducer';

export function ListsOptionsProvider({ children }) {
  useInjectSaga({ key: 'listsOptionsProvider', saga });
  useInjectReducer({ key: 'listsOptionsProvider', reducer });

  return React.Children.only(children);
}

ListsOptionsProvider.propTypes = {
  children: PropTypes.element,
};

const withConnect = connect();

export { default as useListsOptions } from './useListsOptions';
export { default as withListsOptions } from './withListsOptions';
export default compose(withConnect, memo)(ListsOptionsProvider);
